import { TourModel, NotesModel, LookupModel } from "@core/services/api.service";

// Tour list Actions

// Notes Actions
export class LoadNotesAction {
    static readonly type = "[Notes] Load Notes";

    constructor(public payload: { tourId: number }) {}
}

export class LoadNotesSuccessAction {
    static readonly type = "[Notes] Load Notes Success";

    constructor(public payload: { notes: NotesModel[] }) {}
}

export class LoadNotesFailAction {
    static readonly type = "[Notes] Load Notes Fail";
}

export class LoadDepartmentsAction {
    static readonly type = "[Notes] Load Departments";
}

export class LoadDepartmentsSuccessAction {
    static readonly type = "[Notes] Load Departments Success";

    constructor(public payload: { departments: LookupModel[] }) {}
}

export class LoadDepartmentsFailAction {
    static readonly type = "[Notes] Load Departments Fail";
}

export class LoadTypeAction {
    static readonly type = "[Notes] Load Type";

    constructor(public payload: { departmentId: string }) {}
}

export class LoadTypeSuccessAction {
    static readonly type = '[Lookup] Load Type Success';
    constructor(public payload: { types: LookupModel[] }) {}
}

export class LoadTypeFailAction {
    static readonly type = "[Notes] Load Type Fail";
}

export class LoadCategoriesAction {
    static readonly type = "[Notes] Load Categories";
}

export class LoadCategoriesSuccessAction {
    static readonly type = "[Notes] Load Categories Success";

    constructor(public payload: { categories: LookupModel[] }) {}
}

export class LoadCategoriesFailAction {
    static readonly type = "[Notes] Load Categories Fail";
}

export class LoadTicketTypesAction {
    static readonly type = "[TicketTypes] Load Ticket Types";
}

export class LoadTicketTypesSuccessAction {
    static readonly type = "[TicketTypes] Load Ticket Types Success";

    constructor(public payload: { ticketTypes: LookupModel[] }) {}
}

export class LoadTicketTypesFailAction {
    static readonly type = "[TicketTypes] Load Ticket Types Fail";
}

export class LoadGetCauseOfIssueUpdateTypesAction {
    static readonly type = "[CauseOfIssue] Load Cause Of Issue Types";
}

export class LoadGetCauseOfIssueUpdateTypesSuccessAction {
    static readonly type = "[CauseOfIssue] Load Cause Of Issue Types Success";

    constructor(public payload: { causeOfIssueTypes: LookupModel[] }) {}
}

export class LoadGetCauseOfIssueUpdateTypesFailAction {
    static readonly type = "[CauseOfIssue] Load Cause Of Issue Types Fail";
}

export class LoadGetImpactUpdateTypesAction {
    static readonly type = "[ImpactTypes] Load Impact Types Types";
}

export class LoadGetImpactUpdateTypesSuccessAction {
    static readonly type = "[ImpactTypes] Load Impact Types Success";

    constructor(public payload: { impactTypes: LookupModel[] }) {}
}

export class LoadGetImpactUpdateTypesFailAction {
    static readonly type = "[ImpactTypes] Load Impact Types Fail";
}

export class LoadGetReasonForIssueUpdateTypesAction {
    static readonly type =
        "[ReasonForIssueTypes] Load Reason For Issue Types Types";
}

export class LoadGetReasonForIssueUpdateTypesSuccessAction {
    static readonly type =
        "[ReasonForIssueTypes] Load Reason For Issue Types Success";

    constructor(public payload: { reasonForIssueTypes: LookupModel[] }) {}
}

export class LoadGetReasonForIssueUpdateTypesFailAction {
    static readonly type =
        "[ReasonForIssueTypes] Load Reason For Issue Types Fail";
}

export class LoadShipmentModesAction {
    static readonly type = "[ShipmentMode] Load Shipment Modes";
}

export class LoadShipmentModesSuccessAction {
    static readonly type = "[ShipmentMode] Load Shipment Modes Success";

    constructor(public payload: { shipmentModes: LookupModel[] }) {}
}

export class LoadShipmentModesFailAction {
    static readonly type = "[ShipmentMode] Load Shipment Modes Fail";
}

export class LoadCustomsDepAction {
    static readonly type = "[CustomsDep] Load Customs Departments";
}

export class LoadCustomsDepSuccessAction {
    static readonly type = "[CustomsDep] Load Customs Departments Success";

    constructor(public payload: { customsDep: LookupModel[] }) {}
}

export class LoadCustomsDepFailAction {
    static readonly type = "[CustomsDep] Customs Load Departments Fail";
}


export class LoadDeclarationTypesAction {
    static readonly type = "[DeclarationTypes] Load Declaration Types";
}

export class LoadDeclarationTypesSuccessAction {
    static readonly type = "[DeclarationTypes] Load Declaration Types Success";

    constructor(public payload: { declarationTypes: LookupModel[] }) {}
}

export class LoadDeclarationTypesFailAction {
    static readonly type = "[DeclarationTypes] Load Declaration Types Fail";
}

export class LoadAllTypesAction {
    static readonly type = "[Types] Load All Types";
}

export class LoadAllTypesSuccessAction {
    static readonly type = "[Types] Load All Types Success";

    constructor(public payload: { types: LookupModel[] }) {}
}

export class LoadAllTypesFailAction {
    static readonly type = "[Types] Load All Types Fail";
}
